import { render, staticRenderFns } from "./description2.vue?vue&type=template&id=4208602f&scoped=true&"
import script from "./description2.vue?vue&type=script&lang=ts&"
export * from "./description2.vue?vue&type=script&lang=ts&"
import style0 from "./description2.vue?vue&type=style&index=0&id=4208602f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208602f",
  null
  
)

export default component.exports